import { SET_SKILLS_EXECEPTIONS, SET_SKILLS_OPENING_HOURS } from "./actions";

export function periodsReducer(state, action) {
  switch (action.type) {
    case SET_SKILLS_EXECEPTIONS:
      return { ...state, exceptions: action.exceptions }

    case SET_SKILLS_OPENING_HOURS:
      return { ...state, openingHours: action.openingHours }

    default: return state ?? {}
  }
}
